var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4422_1504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72311 -0.0585938C3.04531 -0.0585938 2.49585 0.490875 2.49585 1.16868V16.7141C2.49585 17.3919 3.04531 17.9414 3.72311 17.9414H14.3594C15.0372 17.9414 15.5867 17.3919 15.5867 16.7141V4.8505L10.6776 -0.0585938H3.72311Z",
    fill: "#20A464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5866 9.04581V4.85263L14.8707 4.13672H11.4183C11.1449 4.13672 11.008 4.46721 11.2013 4.66049L15.5866 9.04581Z",
    fill: "url(#paint0_linear_4422_1504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.678 -0.0585938L15.587 4.8505H11.9052C11.2274 4.8505 10.678 4.30103 10.678 3.62323V-0.0585938Z",
    fill: "#8ED1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.314 8.74023V14.6721H5.76855V8.74023H12.314ZM8.63217 9.55842H6.58673V10.5811H8.63217V9.55842ZM9.45035 10.5811V9.55842H11.4958V10.5811H9.45035ZM8.63217 11.1948H6.58673V12.2175H8.63217V11.1948ZM9.45035 12.2175V11.1948H11.4958V12.2175H9.45035ZM8.63217 12.8311H6.58673V13.8539H8.63217V12.8311ZM9.45035 13.8539V12.8311H11.4958V13.8539H9.45035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4422_1504",
    x1: 13.3487,
    y1: 9.04581,
    x2: 13.3487,
    y2: 4.03445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207E55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4422_1504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsExcel);
export default __webpack_public_path__ + "static/media/Icons_excel.160e2347f07366145927ca63122abc73.svg";
export { ForwardRef as ReactComponent };